import { useQuery } from "@tanstack/react-query";

import { HierarchyApi } from "./api";

/**
 * Resolves branch / ward / constituency IDs to their human names. Uses
 * /me/scope (same query as the wizards), so a single fetch per session
 * powers every list/detail view that needs to label IDs.
 */
export function useScopeNames(): {
  branchName: (id: string | null | undefined) => string;
  wardName: (id: string | null | undefined) => string;
  constituencyName: (id: string | null | undefined) => string;
} {
  const scope = useQuery({ queryKey: ["my-scope"], queryFn: HierarchyApi.myScope });
  const branches = scope.data?.branches ?? [];
  const wards = scope.data?.wards ?? [];
  const cons = scope.data?.constituencies ?? [];

  function lookup<T extends { id: string; name: string }>(arr: T[], id: string | null | undefined) {
    if (!id) return "—";
    const hit = arr.find((x) => x.id === id);
    return hit ? hit.name : id;
  }

  return {
    branchName: (id) => lookup(branches, id),
    wardName: (id) => lookup(wards, id),
    constituencyName: (id) => lookup(cons, id),
  };
}
